import { STATUS } from "../utils/const"

const msgs = {
  [STATUS.ERROR]: "Ошибка",
  [STATUS.SUCCESS]: "Успешно",
  [STATUS.SUCCESS_WITH_ERROR]: "Звершено с ошибкой",
  [STATUS.IN_PROGRESS]: "В процессе",
  [STATUS.INVALID_COOKIES]: "Не валидные куки",
  [STATUS.INVALID_FILES]: "Не валидные файлы",
  [STATUS.INVALID_WAREHOUSE]: "Не валидный склад",
  NO_ACCESS: "Нет доступа",
  UPLOAD_STOCKS: "Ошибки при обновлении остатков",
  realizationreport_id: "Номер отчёта",
  date_from: "Дата начала отчётного периода",
  date_to: "Дата конца отчётного периода",
  create_dt: "Дата формирования отчёта",
  currency_name: "Валюта отчёта",
  suppliercontract_code: "Договор",
  rrd_id: "Номер строки",
  gi_id: "Номер поставки",
  dlv_prc: "Фиксированный коэффициент склада по поставке",
  fix_tariff_date_from: "Дата начала действия фиксации",
  fix_tariff_date_to: "Дата конца действия фиксации",
  subject_name: "Предмет",
  nm_id: "Артикул WB",
  brand_name: "Бренд",
  sa_name: "Артикул продавца",
  ts_name: "Размер",
  barcode: "Баркод",
  gtin: "Дополнительный GTIN",
  doc_type_name: "Тип документа",
  quantity: "Количество",
  retail_price: "Цена розничная",
  retail_amount: "Вайлдберриз реализовал Товар (Пр)",
  sale_percent: "Согласованный продуктовый дисконт, %",
  commission_percent: "Размер кВВ, %",
  office_name: "Склад",
  supplier_oper_name: "Обоснование для оплаты",
  order_dt: "Дата заказа",
  sale_dt: "Дата продажи",
  rr_dt: "Дата операции",
  shk_id: "Штрихкод",
  retail_price_withdisc_rub: "Цена розничная с учётом согласованной скидки",
  delivery_amount: "Количество доставок",
  return_amount: "Количество возврата",
  delivery_rub: "Услуги по доставке товара покупателю",
  gi_box_type_name: "Тип коробов",
  product_discount_for_report: "Итоговая согласованная скидка, %",
  supplier_promo: "Промокод, %",
  ppvz_spp_prc: "Скидка постоянного Покупателя (СПП), %",
  ppvz_kvw_prc_base: "Размер кВВ без НДС, % базовый",
  ppvz_kvw_prc: "Итоговый кВВ без НДС, %",
  sup_rating_prc_up: "Размер снижения кВВ из-за рейтинга, %",
  is_kgvp_v2: "Размер снижения кВВ из-за акции, %",
  ppvz_sales_commission:
    "Вознаграждение с продаж до вычета услуг поверенного, без НДС",
  ppvz_for_pay: "К перечислению продавцу за реализованный товар",
  ppvz_reward: "Возмещение за выдачу и возврат товаров на ПВЗ",
  acquiring_fee: "Эквайринг/Комиссии за организацию платежей",
  acquiring_percent:
    "Размер комиссии за эквайринг/Комиссии за организацию платежей, %",
  payment_processing:
    "Тип платежа за Эквайринг/Комиссии за организацию платежей",
  acquiring_bank: "Наименование банка-эквайера",
  ppvz_vw: "Вознаграждение Вайлдберриз (ВВ), без НДС",
  ppvz_vw_nds: "НДС с вознаграждения Вайлдберриз",
  ppvz_office_name: "Наименование офиса доставки",
  ppvz_office_id: "Номер офиса доставки",
  ppvz_supplier_id: "Номер партнёра",
  ppvz_supplier_name: "Партнёр",
  ppvz_inn: "ИНН партнёра",
  declaration_number: "Номер таможенной декларации",
  bonus_type_name: "Виды логистики, штрафов и корректировок ВВ",
  sticker_id: "Цифровое значение стикера",
  site_country: "Страна продажи",
  srv_dbs: "Признак услуги платной доставки",
  penalty: "Общая сумма штрафов",
  additional_payment: "Корректировка Вознаграждения Вайлдберриз (ВВ)",
  rebill_logistic_cost:
    "Возмещение издержек по перевозке/по складским операциям с товаром",
  rebill_logistic_org: "Организатор перевозки",
  storage_fee: "Хранение",
  deduction: "Удержания",
  acceptance: "Платная приёмка",
  assembly_id: "Номер сборочного задания",
  kiz: "Код маркировки",
  srid: "Уникальный ID заказа",
  report_type: "Тип отчёта",
  is_legal_entity: "Признак B2B-продажи",
  trbx_id: "Номер короба для платной приёмки",
  installment_cofinancing_amount: "Скидка по программе софинансирования",
  wibes_wb_discount_percent: "Скидка Wibes, %",
  cashback_amount:
    "Сумма, удержанная за начисленные баллы программы лояльности",
  cashback_discount: "Компенсация скидки по программе лояльности",
  cashback_commission_change: "Стоимость участия в программе лояльности",
  order_uid: "ID транзакции",
  originalPrice: "ЗАКУП",
  description: "Описание",
  brand: "Бренд",
  name: "Наименование",
  tnved: "ТНВЭД",
  vat: "НДС",
  length: "Длина",
  width: "Ширина",
  height: "Высота",
  weightBrutto: "Вес",
  tradeName: "Торговое наименование",
  overwriteBarcodes: "Перезаписать текущие баркоды",
  overwriteBarcodesHint:
    "При включении текущие баркоды заменяются новым; иначе новый баркод добавляется к существующим. Пустой баркод ничего не меняет",
  kizMarked: "Маркировка КИЗ",
  documents: "Документы",
  documentType: "Тип документа",
  excludeDocuments: "Исключить документы из проверки",
  isEndless: "Бессрочный",
  docNumber: "Номер документа",
  docProductNumber: "Доп. номер документа",
  docApplicant: "Представитель изготовителя",
  docStartDate: "Дата начала",
  docEndDate: "Дата окончания",
  dateCreate: "Дата создания",
  number: "Номер",
  sum: "Сумма",
  skuQuantity: "Количество",
  clientName: "Клиент",
  invoicenumber: "Номер счета",
  order_id: "Номер заказа",
  sku: "Артикул",
  Количество: "Количество",
  priceWithoutNds: "Цена без НДС",
  price: "Цена",
  sumNds: "Сумма НДС",
  sumWithNds: "Сумма с НДС",
  gtd: "Номер ГТД",
  MP_RESALE_OZON: "Озон ресейл",
  MP_RESALE_OZON1: "Озон ресейл",
  GoodCode_description: "артикул продавца с WB",
  nmId_description: "артикул ВБ",
  sku_description: "баркод с WB",
  count_description: "количество товаров продаваемых в карточке (кратность)",
  ozonSku_description: "артикул товара с Озон",
  commission_description: "комиссия товара",
  _installed_price: "Установленная цена",
  _storage_price: "Цена склада",
  _storage: "Склад",
  _installed_date: "Дата обновления цены",
  _total_price: "Итоговая цена закупа",
  article_description: "артикул товара",
  photo1: "Фото 1",
  photo2: "Фото 2",
  photo3: "Фото 3",
  photo4: "Фото 4",
  photo5: "Фото 5",
  photo6: "Фото 6",
  photo7: "Фото 7",
  photo8: "Фото 8",
  photo9: "Фото 9",
  photo10: "Фото 10",
}

export const getMessage = (ident: string | number): string => {
  return msgs[ident as keyof typeof msgs] || String(ident ?? "null")
}
